import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subscription} from 'rxjs';
import { Location, NgClass, NgIf, DecimalPipe } from '@angular/common';
import {ProcessService} from '../../../../../services/user-services/process.service';
import {first} from 'rxjs/operators';
import {UserService} from 'src/app/services/user-services/user.service';
import { TranslateModule } from '@ngx-translate/core';
import { NgxIntlTelInputModule } from '@justin-s/ngx-intl-tel-input';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-code-promo-input',
  templateUrl: './code-promo-input.component.html',
  styleUrls: ['./code-promo-input.component.scss'],
  standalone: true,
  imports: [NgClass, NgIf, MatIconModule, MatFormFieldModule, MatInputModule, FormsModule, NgxIntlTelInputModule, DecimalPipe, TranslateModule]
})
export class CodePromoInputComponent implements OnInit, OnDestroy {

  /**
   * @informationKey   -> Required. Clef de traduction du champ affiché sur /informations (ex: "Frais de réservation" sur /accommodation)
   * @itemPrice        -> Required. Le prix initial, avant toute réduction.
   * @propId           -> Required si process = accommodation. booking.propId.
   *
   * @priceAfterPromoCode -> Renvoie le prix à payer après application d'un code promo ; ou le prix de l'item si clear du code promo
   *
   */
  @Input() public informationKey:string = 'PROCESSES.ACCOMMODATION.PAYMENT.FEES';
  @Input() public itemPrice:number = 390;
  @Input() private propId = null;
  @Output() private priceAfterPromoCode: EventEmitter<number> = new EventEmitter<number>();
  @Output() private enteredPromoCodeData: EventEmitter<any> = new EventEmitter<any>();

  public promoCodeData: any = {loading: false, success: false, error: false, obj: null, submit: false};
  public price: number = 0;
  public isPromoCodeInputDisplay:boolean = false;
  public codePromoValue:string;


  private subscription = new Subscription();
  public currentUrl: string;
  public isMobile: boolean = false;
  public screenWidth;


  constructor(
    private location: Location,
    private processService: ProcessService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.price = this.itemPrice;
    this.isMobile = this.userService.isMobileUser;
    this.getPage();
    this.screenWidth = window.innerWidth;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  /**
   * Récupère l'url actuelle
   * @private
   */
  private getPage(): void {
    this.currentUrl = this.location.path();
    this.subscription.add(this.location.onUrlChange(url => {
      this.currentUrl = url;
    }));
  }


  public clearPromoCode(): void {
    this.isPromoCodeInputDisplay = true;
    this.promoCodeData = {loading: false, success: false, error: false, obj: null, submit: false};
    this.codePromoValue = null;
    this.price = this.itemPrice;
    this.priceAfterPromoCode.emit(this.itemPrice);
    this.enteredPromoCodeData.emit(null);
  }


  public showPromoCodeInput() {
    this.isPromoCodeInputDisplay = true;
  }

  public checkPromoCode() {
    this.promoCodeData.submit = true;
    this.promoCodeData.error = null;
    this.promoCodeData.loading = true;
    this.processService.getPromoCode(this.codePromoValue, this.propId, this.currentUrl.split('/')[2].toUpperCase() )
      .pipe(first())
      .subscribe((response: any) => {
        if (response.status === 'success') {
          this.promoCodeData.obj = response.data;
          this.userService.storeInLocal('promoCode',response.data.name);
          let temp = this.price;
          if (response.data.reductionType === 'percent') {
            const x = (100 - response.data.reduction) / 100;
            this.price *= x;
          } else if (response.data.reductionType === 'subtract') {
            this.price -= response.data.reduction;
          }
          this.userService.storeInLocal('promoCodeAmount',temp - this.price);
          this.priceAfterPromoCode.emit(this.price);
          this.enteredPromoCodeData.emit(this.codePromoValue);
          this.promoCodeData.success = true;
        } else if (response.status === 'error' && (response.data === 'not found' || response.data == 'not allowed')) {
          this.promoCodeData.error = true;
        }
        this.promoCodeData.loading = false;
      },
      () => {
        this.promoCodeData.loading = false;
      });
  }


}
